<div [dir]="functionsUtilsService.getDir()" class="kt-portlet logout chashier-dialog">
	<div class="kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div (click)="onNoClick()">
			<img  class="close" src="./assets/media//cashier/x.svg">
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
			<form  class="kt-form" [formGroup]="form" autocomplete="off">
				<div class="row">
						<div class="col-lg-12 mb-4">
							<img class="logout-img" src="./assets/media//cashier/logout.svg">
						</div>
						<div class="col-lg-12 mb-4 text-center">
							<h4>{{ 'CASHIER.SIGNOUT.AMOUNT_DESC' | translate }}</h4>
						</div>
						<div class="col-lg-12 kt-margin-bottom-20-mobile">
							<mat-form-field  class="mat-form-field-fluid">
								<mat-label>{{ 'CASHIER.SIGNOUT.AMOUNT' | translate }}</mat-label>
								<input matInput type="number" min="0" placeholder="{{ 'CASHIER.SIGNOUT.AMOUNT' | translate }}" formControlName="amount" autocomplete="off"/>
								<mat-error *ngIf="isControlHasError(form,'amount','required')">
									<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
								</mat-error>
								<mat-error *ngIf="isControlHasError(form,'amount','min')">
									<strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}</strong>
								</mat-error>
							</mat-form-field>
						</div>
				</div>
			</form>
		</div>
		<div class="kt-portlet__foot--fit text-right">
			<div class="col-lg-12 d-flex justify-content-center mb-3">
				<button class="btn cutom-btn btn-green"  (click)="onYesClick()" color="primary" cdkFocusInitial [disabled]="viewLoading || form.invalid || !form.dirty">{{'COMMON.SEND' | translate}}</button>
			</div>
		</div>
	</div>
</div>